export function LanguageFilled({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.85742 2.25H12.1426C13.3584 2.25002 14.2388 2.60927 14.8135 3.18457C15.388 3.75983 15.7455 4.6401 15.7422 5.85547V12.1426C15.7422 13.3582 15.3832 14.2386 14.8076 14.8145C14.2318 15.3903 13.3506 15.75 12.1348 15.75H5.85742C4.64173 15.75 3.76126 15.3908 3.18555 14.8145C2.60972 14.2379 2.25 13.3549 2.25 12.1348V5.85742C2.25002 4.64162 2.60975 3.76135 3.18555 3.18555C3.76135 2.60975 4.64162 2.25002 5.85742 2.25ZM9 4.14746C8.29598 4.14746 7.71842 4.70974 7.69043 5.40723H5.25781C4.59342 5.40723 4.02092 5.9089 3.95215 6.57715L3.94531 6.71289L3.95215 6.8457C4.0195 7.50549 4.58106 8.02539 5.25781 8.02539H9.37305C8.84641 9.82601 7.28303 11.1318 5.4541 11.2227L5.25 11.2275C4.57342 11.2275 4.01192 11.7467 3.94434 12.4062L3.9375 12.54L3.94434 12.6738C4.01196 13.3333 4.57345 13.8525 5.25 13.8525C6.75166 13.8525 8.13648 13.3524 9.26758 12.5176C10.265 13.3745 11.4629 13.8525 12.75 13.8525C13.4584 13.8525 14.0623 13.2824 14.0625 12.5479C14.0625 11.8261 13.4717 11.2354 12.75 11.2354C12.1702 11.2354 11.5886 11.0277 11.0605 10.6016C11.5439 9.83188 11.8907 8.9632 12.0615 8.03223H12.7422C13.4639 8.03223 14.0547 7.44144 14.0547 6.71973C14.0545 5.99814 13.4638 5.40723 12.7422 5.40723H10.9502L10.875 5.40039C10.8474 5.40039 10.8223 5.4051 10.7998 5.40723H10.3096C10.2816 4.70974 9.70402 4.14746 9 4.14746Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
